import { createAction, props } from '@ngrx/store';

import { Breakpoint } from '../../../../../breakpoints/config';

export const setBreakpoint = createAction('[Breakpoint] set breakpoint', props<{ breakpoint: Breakpoint; matched: boolean }>());
